module.exports = __webpack_public_path__ + "static/slide4-743x573-c8004998504049378be80cd67071572b.gif";